import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

// eslint-disable-next-line no-undef
const serverUrl = process.env.REACT_APP_SERVER_URL;

const ContactForm = ({ collection, claimId, onFormSuccess }) => {
  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    email: "",
    prova: null,
    messaggio: "",
    privacy: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // formData.prova.toString("base64");
    formData.prova = btoa(formData.prova);
    formData.collection = collection;
    formData.claimId = claimId;
    formData.assignedTo = null;

    await axios.post(serverUrl + "/api/report", formData);

    onFormSuccess(true);
  };

  return (
    <div className="report-card max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">
        Segnalazione di prodotto già registrato
      </h1>
      <p className="mb-8 text-gray-600">
        Lorem ipsum dolor sit amet consectetur. Sodales nisi bibendum neque ut
        eu ut aliquam sed posuere. Risus purus mauris luctus lectus velit sit
        duis maecenas.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="report-field">
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleInputChange}
              placeholder="Nome*"
              required
              className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none"
            />
          </div>
          <div className="report-field">
            <input
              type="text"
              name="cognome"
              value={formData.cognome}
              onChange={handleInputChange}
              placeholder="Cognome*"
              required
              className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none"
            />
          </div>
        </div>

        <div className="report-field">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Email*"
            required
            className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none"
          />
        </div>

        <div className="report-upload flex items-center justify-between border-b border-gray-300 py-2">
          <span className="text-gray-600">{"Prova d'acquisto"}</span>
          <label className="bg-gray-500 text-white px-4 py-2 rounded cursor-pointer">
            Sfoglia
            <input
              type="file"
              name="prova"
              onChange={handleInputChange}
              className="hidden"
            />
          </label>
        </div>

        <div className="report-field">
          <textarea
            name="messaggio"
            value={formData.messaggio}
            onChange={handleInputChange}
            placeholder="Messaggio"
            rows="4"
            className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none resize-none"
          />
        </div>

        <div className="report-privacy flex items-start space-x-2">
          <input
            type="checkbox"
            name="privacy"
            checked={formData.privacy}
            onChange={handleInputChange}
            required
            className="mt-1"
          />
          <label className="text-sm text-gray-600">
            Cliccando qui, accetti i termini della nostra Privacy Policy
          </label>
        </div>

        <div>
          <button
            type="submit"
            className="text-white px-8 py-2 rounded flex items-center bg-gray-500"
          >
            Invia
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

const Report = () => {
  const config = useSelector((state) => state.config);
  const { collection } = useParams();
  const { claimId } = useParams();
  const navigate = useNavigate();
  const [formSent, setFormSent] = useState(false);
  //   const [isLegitClaim, setIsLegitClaim] = useState();
  //   const [isCheckingLegitimacy, setIsCheckingLegitimacy] = useState(true);

  /**
   * Effect hook to validate collection access
   * Redirects if collection is not in authorized list
   */
  useEffect(() => {
    if (config && config?.clientConfig?.data?.collections) {
      if (!config?.clientConfig?.data?.collections.includes(collection)) {
        navigate("/");
      }
    }
    // 0xF9c041B359453C69395f1C21713C795f84A78731
    // cf95d1fd80f45477ac3871537017e3b1

    // console.log("collection", collection);
    // console.log("claimId", claimId);
    // console.log("config", config?.clientConfig?.data?.collections);
  }, [collection, claimId, config, navigate]);

  const onFormSuccess = (data) => {
    setFormSent(data);
  };

  if (!formSent) {
    return (
      <div className="report-page report-section container-cust mx-auto">
        <ContactForm
          collection={collection}
          claimId={claimId}
          onFormSuccess={onFormSuccess}
        />
      </div>
    );
  }

  if (formSent) {
    return (
      <div className="report-page report-section report-success max-w-3xl mx-auto text-center py-12">
        <h1 className="text-2xl font-bold mb-4">Grazie per la segnalazione</h1>

        <p className="mb-8 text-gray-600">
          Lorem ipsum dolor sit amet consectetur. Sodales nisi bibendum neque ut
          eu ut aliquam sed posuere. Risus purus mauris luctus lectus velit sit
          duis maecenas.
        </p>

        <button
          onClick={() => navigate("/collections")}
          className="bg-gray-500 text-white px-6 py-3 rounded hover:bg-gray-600 transition-colors"
        >
          VAI ALLA PAGINA COLLEZIONI
        </button>
      </div>
    );
  }
};

export default Report;
